document.addEventListener('DOMContentLoaded', () => {
  // FAQ toggle indicator
  document.querySelectorAll('.faq__item').forEach((details) => {
    details.addEventListener('toggle', () => {
      const t = details.querySelector('.faq__toggle');
      if (t) t.textContent = details.open ? '×' : '+';
    });
  });

  // Mobile menu
  const menuBtn = document.querySelector('.header__menu-toggle');
  const nav = document.querySelector('.header__nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', () => nav.classList.toggle('is-open'));
  }
});

// Add to cart
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action$="/cart/add"]');
  if (!form) return;
  e.preventDefault();
  try {
    await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    window.location.href = '/cart';
  } catch (err) { console.error(err); }
});
